import React from 'react';
import classnames from 'classnames';

import style from './package-item.module.less';

/**
 * @typedef {object} PackageItemRowProps
 * @property {string} [className=''] - Additional CSS class name
 * @property {React.ReactNode} content - Content to display in the row
 * @property {React.ReactNode} label - Label for the row
 * @property {string} [labelId] - ID for the label element
 */

/**
 * Row component for package item display
 * @param {PackageItemRowProps} props
 * @returns {React.ReactElement}
 */
export const PackageItemRow = ({ className = '', label, content, labelId }) => {
  return (
    <div className={classnames(style.row, className)}>
      <label className={style['row-label']} htmlFor={labelId} id={labelId}>
        {label}
      </label>
      <div className={style.content}>{content}</div>
    </div>
  );
};
